var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"custom-v-select-sm",attrs:{"label":"name","options":_vm.getOptions,"value":_vm.value,"clearable":false,"reduce":function (r) { return r.id; }},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }